import useCurrentAuth from './useCurrentAuth'

function useIsCurrentUserInternal() {
  const { currentUser } = useCurrentAuth()

  return Boolean(
    currentUser?.user_roles?.includes('admin') ||
      currentUser?.user_roles?.includes('internal'),
  )
}

export default useIsCurrentUserInternal
